// breakpoints
export const breakpoints = ['48em', '64em', '72em']; // defaults to: 768px (tablet), 1024px (laptop), 1152px (laptop M)

export const mediaQueries = {
  small: `@media screen and (min-width: ${breakpoints[0]})`,
  medium: `@media screen and (min-width: ${breakpoints[1]})`,
  large: `@media screen and (min-width: ${breakpoints[2]})`
};
const [sm, md, lg] = breakpoints;
breakpoints.sm = sm;
breakpoints.md = md;
breakpoints.lg = lg; // font

export const fontFamily = 'Roboto, Arial, Helvetica, sans-serif';
export const Helvetica = 'Helvetica, sans-serif';
export const fontSizes = [12, 14, 16, 18, 20, 24, 32, 36, 40, 56, 72];
export const fontWeights = {
  light: 300,
  regular: 400,
  medium: 500,
  bold: 700
}; // https://css3-tutorial.net/text-font/font-weight/

export const lineHeights = {
  thin: 12,
  standard: 14,
  plus: 16,
  tall: 18,
  display: 1.25,
  small: 0.8,
  fontSize: 1,
  input: 1.4,
  big: 1.6
};
export const zIndices = [1, 10, 1040, 1050, 1060]; // spaces

const space = [0, 4, 8, 16, 32, 64, 128, 256, 512]; // ref: [https://magazine.atlassian.net/wiki/spaces/DSM/pages/941261008/Cores]

export const baseColors = {
  magablu: {
    base: '#0086ff',
    light: '#e5f3ff',
    dark: '#005eb2'
  },
  lima: {
    base: '#00d604',
    light: '#edfaee',
    dark: '#008002'
  },
  pizza: {
    base: '#ff8a00',
    light: '#ffe8cc',
    dark: '#b26100'
  },
  vermillion: {
    base: '#ff253a',
    light: '#ffe5e8',
    dark: '#b20919'
  },
  gold: {
    base: '#fcd000',
    light: '#fcf3ca',
    dark: '#cca800'
  },
  shock: {
    base: '#a400e1',
    light: '#ecdaf2',
    dark: '#6c0094'
  },
  fini: {
    base: '#ff37a8',
    light: '#fddcef',
    dark: '#b22676'
  },
  wildsand: {
    base: '#f4f4f4',
    light: '#fafafa',
    dark: '#e5e5e5'
  },
  gray: {
    base: '#8c8c8c',
    light: '#b9b9b9',
    dark: '#404040'
  },
  white: {
    base: '#ffffff'
  },
  overlay: {
    base: 'rgba(0, 0, 0, 0.63)',
    dark: 'rgba(0, 0, 0, 0.80)',
    light: 'rgba(229, 229, 229, 0.80)'
  }
}; // color palette

const base = '#ffffff';
const black = '#010101';
const white = '#fefefe';
const lightGray = '#ededed';
const lightSilver = '#ececec';
const orange = '#eb8636';
const red = '#c00';
const gray = '#9b9b9b';
const greyish = '#aaaaaa';
const greyishBrown = '#515151';
const greyishBlue = '#cce6f4';
const darkGray = '#808080';
const whisper = '#e5e5e5';
const silver = '#bcbcbc';
const darkSilver = '#404040';
const green = '#59c00b';
const darkGreen = '#479908';
const limeGreen = '#47FF97';
const deepGreen = '#11C11B';
const blue = '#0086ff';
const darkBlue = '#005eb2';
const lightBlue = '#aad0e6';
const pink = '#a23f97';
const davysGray = '#595959';
export const opacityBlue = 'rgba(0, 134, 255, 0.11);';
export const colors = {
  base,
  black,
  white,
  lightGray,
  lightSilver,
  orange,
  red,
  silver,
  darkSilver,
  gray,
  greyish,
  greyishBrown,
  greyishBlue,
  darkGray,
  green,
  darkGreen,
  limeGreen,
  deepGreen,
  blue,
  darkBlue,
  lightBlue,
  whisper,
  pink,
  opacityBlue,
  davysGray
}; // boxShadows

export const boxShadows = [`0 0 2px 0 rgba(0,0,0,.08),0 1px 4px 0 rgba(0,0,0,.16)`, `0 0 2px 0 rgba(0,0,0,.08),0 2px 8px 0 rgba(0,0,0,.16)`, `0 0 2px 0 rgba(0,0,0,.08),0 4px 16px 0 rgba(0,0,0,.16)`, `0 0 2px 0 rgba(0,0,0,.08),0 8px 32px 0 rgba(0,0,0,.16)`, `0px 2px 12px rgba(81, 81, 81, 0.12)`];
export const elevations = [`0 0 0 0 rgba(0,0,0,.2), 0 0 0 0 rgba(0,0,0,.14), 0 0 0 0 rgba(0,0,0,.12)`, `0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)`, `0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12)`, `0 3px 3px -2px rgba(0,0,0,.2), 0 3px 4px 0 rgba(0,0,0,.14), 0 1px 8px 0 rgba(0,0,0,.12)`, `0 3px 3px -2px rgba(0,0,0,.2), 0 3px 4px 0 rgba(0,0,0,.14), 0 1px 8px 0 rgba(0,0,0,.12)`, `0 3px 5px -1px rgba(0,0,0,.2), 0 5px 8px 0 rgba(0,0,0,.14), 0 1px 14px 0 rgba(0,0,0,.12)`, `0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12)`, `0 4px 5px -2px rgba(0,0,0,.2), 0 7px 10px 1px rgba(0,0,0,.14), 0 2px 16px 1px rgba(0,0,0,.12)`, `0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12)`, `0 5px 6px -3px rgba(0,0,0,.2), 0 9px 12px 1px rgba(0,0,0,.14), 0 3px 16px 2px rgba(0,0,0,.12)`, `0 6px 6px -3px rgba(0,0,0,.2), 0 10px 14px 1px rgba(0,0,0,.14), 0 4px 18px 3px rgba(0,0,0,.12)`, `0 6px 7px -4px rgba(0,0,0,.2), 0 11px 15px 1px rgba(0,0,0,.14), 0 4px 20px 3px rgba(0,0,0,.12)`, `0 7px 8px -4px rgba(0,0,0,.2), 0 12px 17px 2px rgba(0,0,0,.14), 0 5px 22px 4px rgba(0,0,0,.12)`, `0 7px 8px -4px rgba(0,0,0,.2), 0 13px 19px 2px rgba(0,0,0,.14), 0 5px 24px 4px rgba(0,0,0,.12)`, `0 7px 9px -4px rgba(0,0,0,.2), 0 14px 21px 2px rgba(0,0,0,.14), 0 5px 26px 4px rgba(0,0,0,.12)`, `0 8px 9px -5px rgba(0,0,0,.2), 0 15px 22px 2px rgba(0,0,0,.14), 0 6px 28px 5px rgba(0,0,0,.12)`, `0 8px 10px -5px rgba(0,0,0,.2), 0 16px 24px 2px rgba(0,0,0,.14), 0 6px 30px 5px rgba(0,0,0,.12)`, `0 8px 11px -5px rgba(0,0,0,.2), 0 17px 26px 2px rgba(0,0,0,.14), 0 6px 32px 5px rgba(0,0,0,.12)`, `0 9px 11px -5px rgba(0,0,0,.2), 0 18px 28px 2px rgba(0,0,0,.14), 0 7px 34px 6px rgba(0,0,0,.12)`, `0 9px 12px -6px rgba(0,0,0,.2), 0 19px 29px 2px rgba(0,0,0,.14), 0 7px 36px 6px rgba(0,0,0,.12)`, `0 10px 13px -6px rgba(0,0,0,.2), 0 20px 31px 3px rgba(0,0,0,.14), 0 8px 38px 7px rgba(0,0,0,.12)`, `0 10px 13px -6px rgba(0,0,0,.2), 0 21px 33px 3px rgba(0,0,0,.14), 0 8px 40px 7px rgba(0,0,0,.12)`, `0 10px 14px -6px rgba(0,0,0,.2), 0 22px 35px 3px rgba(0,0,0,.14), 0 8px 42px 7px rgba(0,0,0,.12)`, `0 11px 14px -7px rgba(0,0,0,.2), 0 23px 36px 3px rgba(0,0,0,.14), 0 9px 44px 8px rgba(0,0,0,.12)`, `0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12)`];
const borders = [`1px solid ${colors.lightGray}`, `2px solid ${colors.silver}`, `3px solid ${colors.silver}`, `4px solid ${colors.lightGray}`];
export const textContrast = {
  light: colors.base,
  dark: colors.black
}; // border-radius

export const radii = {
  small: '2px',
  medium: '4px',
  default: '6px',
  plus: '12px',
  big: '20px',
  large: '40px',
  circle: '50%'
};
export const cursor = {
  pointer: 'pointer',
  default: 'default',
  'not-allowed': 'not-allowed'
};
const theme = {
  baseColors,
  boxShadows,
  borders,
  breakpoints,
  colors,
  cursor,
  elevations,
  fontFamily,
  fontSizes,
  fontWeights,
  Helvetica,
  lineHeights,
  mediaQueries,
  radii,
  space,
  textContrast,
  zIndices,
  zIndex: zIndices,
  shadows: boxShadows
};
export default theme;